import React, { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Stack,
  TextField,
  Typography,
  MenuItem,
  FormControl,
  Select,
  ListItemText
} from "@mui/material";
import { useSelector } from "react-redux";
import useSuperCategoryList from "../../hooks/useSuperCategoryList";

const AddDeliveryBoyForm = ({ open, onClose, onSubmit, value, areaNameList, areaData, setAreaData }) => {
  const getDropDownData = useSelector((state) => state.app.curretDropdownData);
  

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    zone_id: getDropDownData?.zone_id,
    mobile_no: "",
    sc_id: [],
  });

  const [selectedScId, setSelectedScId] = useState([]);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      zone_id: getDropDownData?.zone_id,
    }));
  }, [getDropDownData, open]);

  const handleAreaChange = (e)=>{
    const selectedValue = e.target.value;

    const selectedIds = selectedValue?.map((selectedArea) => {
      const foundArea = areaNameList?.find(
        (area) => area.area_name === selectedArea
      );
      return foundArea ? foundArea?.shape_id : null;
    });
    
    setAreaData((prev)=>({
      ...prev,
      selectedArea: selectedValue,
      selectedShapeId: selectedIds?.filter((shape_id)=> shape_id!=null)
    }))
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      sc_id: selectedScId,
    }));
  }, [selectedScId]);

  const validateMobileNumber = () => {
    const mobileNumber = formData.mobile_no;

    // Check if the mobile number is a string of 10 digits
    if (mobileNumber && mobileNumber.length === 10 && !isNaN(mobileNumber)) {
      return true;
    }

    return false;
  };

  const handleFormSubmit = () => {
    const newErrors = {};

    // Validate first_name and last_name
    if (!formData.first_name.trim()) {
      newErrors.first_name = "First Name is required";
    }

    if (!formData.last_name.trim()) {
      newErrors.last_name = "Last Name is required";
    }

    // Validate mobile_no
    if (!formData.mobile_no.trim()) {
      newErrors.mobile_no = "Mobile Number is required";
    } else if (!validateMobileNumber()) {
      newErrors.mobile_no = "Invalid Mobile Number";
    }

    // If there are errors, setErrors and return
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // If no errors, submit the form
    onSubmit(formData);
    onClose();
    setFormData({});
    setErrors({});
    setAreaData({
      selectedArea: [],
      selectedShapeId: []
    })
  };

  const handleClose = () => {
    onClose();
    setFormData({
      name: "",
      zone_id: getDropDownData.zone_id,
      mobile_no: "",
      sc_id: [],
    });
    setErrors({});
    setAreaData({
      selectedArea: [],
      selectedShapeId: []
    })
  };

  useSuperCategoryList();

  const superCategoryList = useSelector(
    (state) => state.superCategory.superCategoryList
  );

  const handleSCChange = (e, scId) => {
    let updatedScId = [...selectedScId];

    if (e.target.checked) {
      // If the checkbox is checked, add the scId to the array
      updatedScId.push(scId);
    } else {
      // If the checkbox is unchecked, filter out the scId from the array
      updatedScId = updatedScId.filter((sc) => sc !== scId);
    }

    setSelectedScId(updatedScId); // Update the state with the new array
  };

  return (
    <Dialog
      maxWidth={"800px"}
      open={open}
      onClose={onClose}
      sx={{ width: "50vw", margin: "auto" }}
    >
      <DialogTitle>Add Delivery Boy</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "40vw",
        }}
      >
        <label htmlFor="first_name">First Name:</label>
        <TextField
          size="small"
          type="text"
          id="first_name"
          name="first_name"
          value={formData.first_name}
          onChange={handleInputChange}
          fullWidth
          required
          error={Boolean(errors.first_name)}
          helperText={errors.first_name}
        />

        <label htmlFor="last_name">Last Name:</label>
        <TextField
          size="small"
          type="text"
          id="last_name"
          name="last_name"
          value={formData.last_name}
          onChange={handleInputChange}
          fullWidth
          required
          error={Boolean(errors.last_name)}
          helperText={errors.last_name}
        />

        <label htmlFor="zone_id">Zone Name:</label>
        <TextField
          size="small"
          type="text"
          id="zone_id"
          name="zone_id"
          value={getDropDownData?.zone_name}
          onChange={handleInputChange}
          fullWidth
          disabled
        />

        <label htmlFor="mobile_no">Mobile Number:</label>
        <TextField
          size="small"
          type="text"
          id="mobile_no"
          name="mobile_no"
          value={formData.mobile_no}
          onChange={handleInputChange}
          fullWidth
          required
          error={Boolean(errors.mobile_no)}
          helperText={errors.mobile_no}
        />
        {value === 2 ||
          (value === "2" && (
            <>
              <label htmlFor="mobile_no">Area Name:</label>
              <FormControl sx={{ minWidth: 250 }}>
                {/* <InputLabel sx={{ top: "-10px", color: "#989797" }}>
            Area Name
          </InputLabel> */}
                <Select
                  labelId="shape-id-label"
                  id="shape-id-select"
                  name="sku_id"
                  value={areaData?.selectedArea}
                  size="small"
                  renderValue={(selected) => {
                    if (selected.length > 2) {
                      return `${selected.slice(0, 2).join(", ")}...`;
                    }
                    return selected.join(", ");
                  }}
                  // renderValue={() => null}
                  multiple
                  sx={{ height: "2.2rem" }}
                  onChange={(e) => handleAreaChange(e)}
                >
                  {/* <MenuItem
              value="All"
              key={0}
              sx={{
                padding: "2px",
                marginTop: "-8px",
              }}
            >
              {" "}
              <Checkbox
                checked={areaNameList
                  // ?.filter((category) => category.status === true)
                  ?.every((area) => areaData?.selectedShapeId?.includes(area.shape_id))}
              />
              <ListItemText
                primary={<span style={{ fontWeight: "bold" }}>Select All</span>}
              />
            </MenuItem> */}
                  {areaNameList &&
                    areaNameList
                      ?.filter((area) => area.area_name != "ALL")
                      .map((area) => (
                        <MenuItem
                          key={area?.shape_id}
                          value={area?.area_name}
                          sx={{
                            padding: "2px",
                            marginTop: "-8px",
                          }}
                        >
                          <Checkbox
                            checked={
                              areaData?.selectedArea?.indexOf(
                                area?.area_name
                              ) >= 0
                            }
                          />
                          <ListItemText primary={area?.area_name} />
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>
            </>
          ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
            handleClose();
          }}
          sx={{ color: "gray" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleFormSubmit}
          variant="contained"
          sx={{
            backgroundColor: "#DC1D13",
            ":hover": {
              backgroundColor: "#960c08",
            },
          }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDeliveryBoyForm;
